import styled from 'styled-components';

export const ThankYouContainer = styled.div`
    height: 500px;
    margin: 80px auto;

    h1{
        font-family: "Tobi Pro", sans-serif;
        color: #008944;
        font-size: 50px;
        margin-bottom: 20px;
    }

    .custom-card {
        border: 1px solid #008944;
        padding: 30px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;
